import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import './scss/style.scss';
import { translate } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        display: 'inline-block',
        maxHeight: '100vh',
        overflow: 'auto'
    },
}));

function CreateSalaryOrderModal(props) {
    const classes = useStyles();

    let { t, createFeedbackMessage, errorMessageCode } = props;

    return (
        <div>
            <Modal
                open={props.open}
                // onClose={close}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                classes={classes.modal}
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description">
                <Fade in={props.open}>
                    <div className={classes.paper}>
                        {
                            props.data &&
                            <div className="payment-modal-succes">
                                <div className="payment-modal-succes-left justify-content-center">
                                    {props.data.currency &&
                                        <div className="payment-modal-succes-partial-left-inp">
                                            <label style={{ color: "#0179D2" }}>{props.t('Card currency')}</label>
                                            <span>{props.data.currency}</span>
                                        </div>}
                                    {props.data.duration && <div className="payment-modal-succes-partial-left-inp">
                                        <label style={{ color: "#0179D2" }}>{props.t('Card period')}</label>
                                        <span>{props.data.duration}</span>
                                    </div>}
                                    {props.data.count && <div className="payment-modal-succes-partial-left-inp">
                                        <label style={{ color: "#0179D2" }}>{props.t('Card count')}</label>
                                        <span>{props.data.count}</span>
                                    </div>}
                                    {props.data.branch && <div className="payment-modal-succes-partial-left-inp">
                                        <label style={{ color: "#0179D2" }}>{props.t('branch')}</label>
                                        <span>{props.data.branch}</span>
                                    </div>}
                                    {props.data.fee && <div className="payment-modal-succes-partial-left-inp">
                                        <label style={{ color: "#0179D2" }}>{props.t('Service fee')}</label>
                                        <span>{props.data.fee}</span>
                                    </div>}
                                    {props.data.account && <div className="payment-modal-succes-partial-left-inp">
                                        <label style={{ color: "#0179D2" }}>{props.t('Account for service fee deduction')}</label>
                                        <span>{props.data.account}</span>
                                    </div>}
                                    {props.data.accounts?.length > 0 && <div className="payment-modal-succes-partial-left-inp">
                                        <label style={{ color: "#0179D2" }}>{props.t('Account to connect')}</label>
                                        <ul className='p-0 mb-0 mt-1'>
                                            {props.data.accounts.map(item =>
                                                <li>{item.iban}</li>
                                            )}
                                        </ul>
                                    </div>}
                                    {props.data.projectType && <div className="payment-modal-succes-partial-left-inp">
                                        <label style={{ color: "#0179D2" }}>{props.t('Project type')}</label>
                                        <span>{props.data.projectType}</span>
                                    </div>}
                                    {props.data.serviceTariff && <div className="payment-modal-succes-partial-left-inp">
                                        <label style={{ color: "#0179D2" }}>{props.t('Service Fee')}</label>
                                        <span>{props.data.serviceTariff}</span>
                                    </div>}
                                    {props.data.individualTariff && <div className="payment-modal-succes-partial-left-inp">
                                        <label style={{ color: "#0179D2" }}>{props.t('Individual tariff')}</label>
                                        <span>{props.data.individualTariff}</span>
                                    </div>}
                                    {props.data.contractPeriod && <div className="payment-modal-succes-partial-left-inp">
                                        <label style={{ color: "#0179D2" }}>{props.t('Contract period')}</label>
                                        <span>{props.data.contractPeriod}</span>
                                    </div>}
                                </div>
                                <div className="payment-modal-succes-right" style={{ justifyContent: 'flex-start' }}>
                                    <div style={{ justifyContent: 'center', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <svg width="124" height="124" viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M62 124C96.2417 124 124 96.2417 124 62C124 27.7583 96.2417 0 62 0C27.7583 0 0 27.7583 0 62C0 96.2417 27.7583 124 62 124Z" fill="#F2F8FD" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M62.2463 107.762C87.3841 107.762 107.762 87.3838 107.762 62.246C107.762 37.1083 87.3841 16.7302 62.2463 16.7302C37.1086 16.7302 16.7305 37.1083 16.7305 62.246C16.7305 87.3838 37.1086 107.762 62.2463 107.762Z" fill="#0179D2" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M55.8465 75.7892L43.3726 63.3154C42.6232 62.566 42.6232 61.3509 43.3726 60.6014L46.0865 57.8875C46.8359 57.138 48.051 57.138 48.8005 57.8875L57.2034 66.2904L75.2016 48.2922C75.951 47.5428 77.1661 47.5428 77.9156 48.2922L80.6294 51.0062C81.3789 51.7556 81.3789 52.9707 80.6294 53.7201L58.5603 75.7893C57.8109 76.5387 56.5958 76.5387 55.8465 75.7892Z" fill="white" />
                                        </svg>
                                        <div>
                                            <h2>{props.t('successful operation')}</h2>
                                            <p className='mt-2'>{props.t('Go to the authorization page to complete the operation')}</p>
                                        </div>
                                    </div>
                                    <button className="header-sign-section-container-form-button payment-modal-template-save mt-0" onClick={props.successClose} >{props.t('Click to confirm')}</button>
                                    <button className="header-sign-section-container-form-button payment-modal-template-close" onClick={props.close} >{props.t('close')}</button>
                                </div>
                            </div>
                        }
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}

export default translate("translation")(CreateSalaryOrderModal);

